// extracted by mini-css-extract-plugin
export default {"Info":"_Info--SlLCM","Error":"_Error--RdKDT","Warning":"_Warning--BSzfD","IconContainer":"_IconContainer--tH3rv","Content":"_Content--MUdrr","Header":"_Header--bM3IA"};